import Icon from "@mui/material/Icon";

// Import company pages
import Overview from "layouts/pages/about-us/company/overview";
import OurBrand from "layouts/pages/about-us/company/our-brand";
import Career from "layouts/pages/about-us/company/career";
import Blog from "layouts/pages/blog";

// Import support pages
import ContactUs from "layouts/pages/about-us/support/contact-us";
import Privacy from "layouts/pages/about-us/support/privacy";

// Import services pages

// Red Team & Readiness
import RedTeam from "layouts/pages/services/red-team";
import SocialEngineering from "layouts/pages/services/social-engineering";
import RandomwareReadiness from "layouts/pages/services/ransomware-readiness";
import DenyOfService from "layouts/pages/services/deny-of-service";

// Network Security
import InternalPentesting from "layouts/pages/services/internal-pentesting";
import ExternalPentesting from "layouts/pages/services/external-pentesting";
import CountinuousPentesting from "layouts/pages/services/continuous-pentesting";

// Application Security
import WebPentesting from "layouts/pages/services/web-pentesting";
import DesktopPentesting from "layouts/pages/services/desktop-pentesting";
import MobilePentesting from "layouts/pages/services/mobile-pentesting";
import Web3Pentesting from "layouts/pages/services/web3-pentesting";

// Cloud Security
import CloudSecurity from "layouts/pages/services/cloud-security";

// Vulnerability Management
import VulnerabilityManagement from "layouts/pages/services/vulnerability-management";

// Training & Awareness
import Academy from "layouts/pages/academy";

const routes = [
  {
    name: "Sobre nosotros",
    icon: <Icon>dashboard</Icon>,
    columns: 2,
    rowsPerColumn: 2,
    collapse: [
      {
        name: "empresa",
        collapse: [
          {
            name: "visión general",
            route: "/company/overview",
            component: <Overview />,
          },
          {
            name: "nuestra marca",
            route: "/company/our-brand",
            component: <OurBrand />,
          },
          {
            name: "carrera",
            route: "/company/career",
            component: <Career />,
          },
        ],
      },
      {
        name: "soporte",
        collapse: [
          {
            name: "contáctenos",
            route: "/support/contact-us",
            component: <ContactUs />,
          },
          {
            name: "privacidad",
            route: "/support/privacy",
            component: <Privacy />,
          },
        ],
      },
      {
        name: "recursos",
        collapse: [
          {
            name: "Blog",
            route: "/blog",
            component: <Blog />,
          },
          {
            name: "I+D",
            route: "https://euniv.eu/es/investigacion/instituto-universitario-laurentia/",
            component: <Privacy />,
          },
        ],
      },
    ],
  },
  {
    name: "servicios",
    icon: <Icon>view_carousel</Icon>,
    dropdown: true,
    collapse: [
      {
        name: "red team y preparación",
        dropdown: true,
        description: "5 servicios",
        collapse: [
          {
            name: "red team",
            route: "/services/red-team",
            component: <RedTeam />,
          },
          {
            name: "ingeniería social",
            route: "/services/social-engineering",
            component: <SocialEngineering />,
          },
          {
            name: "preparación contra ransomware",
            route: "/services/ransomware-readiness",
            component: <RandomwareReadiness />,
          },
          {
            name: "DoS / DDoS",
            route: "/services/deny-of-service",
            component: <DenyOfService />,
          },
        ],
      },
      {
        name: "seguridad de red",
        description: "3 servicios",
        dropdown: true,
        collapse: [
          {
            name: "interna",
            route: "/services/internal-pentesting",
            component: <InternalPentesting />,
          },
          {
            name: "externa",
            route: "/services/external-pentesting",
            component: <ExternalPentesting />,
          },
          {
            name: "continua",
            route: "/services/continuos-pentesting",
            component: <CountinuousPentesting />,
          },
        ],
      },
      {
        name: "seguridad de aplicaciones",
        description: "4 servicios",
        dropdown: true,
        collapse: [
          {
            name: "web",
            route: "/services/web-pentesting",
            component: <WebPentesting />,
          },
          {
            name: "escritorio",
            route: "/services/desktop-pentesting",
            component: <DesktopPentesting />,
          },
          {
            name: "móvil",
            route: "/services/mobile-pentesting",
            component: <MobilePentesting />,
          },
          {
            name: "web 3.0 / blockchain",
            route: "/services/web3-pentesting",
            component: <Web3Pentesting />,
          },
        ],
      },
      {
        name: "seguridad en la nube",
        route: "/services/cloud-security",
        component: <CloudSecurity />,
      },
      {
        name: "gestión de vulnerabilidades",
        route: "/services/vulnerability-management",
        component: <VulnerabilityManagement />,
      },
      {
        name: "Formación y Concienciación",
        route: "/academy",
        component: <Academy />,
      },
    ],
  },
  {
    name: "blog",
    icon: <Icon>menu_book</Icon>,
    route: "/blog",
    component: <Blog />,
  },
  {
    name: "academia",
    icon: <Icon>school</Icon>,
    route: "/academy",
    component: <Academy />,
  },
  {
    name: "idioma",
    icon: <Icon>translate</Icon>,
    dropdown: true,
    collapse: [
      {
        name: "inglés",
        route: "https://en.pwncat.com",
      },
    ]
  },
];

export default routes;